export default function convertAudioTitle(str) {
  return str
    .replace(/\d{1,2}[.]\d{1,2}/g, "")
    .replace(/[^-a-zA-Z0-9 \u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00df]/g, "")
    .replace(/\s+$/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
}
